import React from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';
import {defaultTheme} from '../../data/themes';
import Centerer from '../containers/centerer';
import Button from '../forms/button';
import TextInput from '../forms/textinput';
import Form from '../forms/form';
import FormItem from '../forms/formitem';
import Icon from '../icon';
import { getPhrase } from '../../data/phrases';
import RootModalContainer from '../containers/rootmodalcontainer';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);

// 	background: ${props => props.theme.pendingRequestOverlayBackground || defaultTheme.pendingRequestOverlayBackground};

const PendingRequestContainer = styled.div`
	position: absolute;
	left: 0px;
	top: 0px;
	height: 100%;
	width: 100%;
	.icon {
		margin-left: 8px;
		position: relative;
		top: -1px;
		font-size: ${props => props.theme.pendingRequestSpinnerSize || defaultTheme.pendingRequestSpinnerSize};
	}
	text-align: center;

	.messages {
		margin-top: 8px;
		color: ${props => props.theme.pendingRequestMessageColor || defaultTheme.pendingRequestMessageColor};
		font-size: ${props => props.theme.pendingRequestMessageFontSize || defaultTheme.pendingRequestMessageFontSize};
		font-weight: ${props => props.theme.pendingRequestMessageFontWeight || defaultTheme.pendingRequestMessageFontWeight};
	}
`;


const Dialog = styled.div`
	padding: ${props => props.theme.dialogPadding ?? defaultTheme.dialogPadding};
	border-radius: ${props => props.theme.dialogBorderRadius ?? defaultTheme.dialogBorderRadius};
	border: ${props => props.theme.dialogBorder ?? defaultTheme.dialogBorder};
	box-shadow: ${props => props.theme.dialogShadow ?? defaultTheme.dialogShadow};
	background-color: ${props => props.theme.dialogBackground ?? defaultTheme.dialogBackground};
	min-width: 220px;
`;

const DialogContent = styled.div`
	padding-bottom: 16px;
	white-space: pre-wrap;
`;

const MessageBoxHeader = styled.div`
	font-weight: ${props => props.theme.dialogHeaderFontWeight ?? defaultTheme.dialogHeaderFontWeight};
	font-size: ${props => props.theme.dialogHeaderFontSize};
	margin: 8px;
`


const Buttons = styled.div`
	text-align: right;
	[type=light] {
		margin-right:32px;
	}
`;


// 	background: ${props => props.theme.modalOverlayBackground || defaultTheme.modalOverlayBackground};

const MessageBoxContainer = styled.div`
	position: absolute;
	left: 0px;
	top: 0px;
	height: 100%;
	width: 100%;

`;


export default class Modals extends React.PureComponent {


	renderPendingRequests(pendingRequests) {
		if (pendingRequests.size === 0) {
			return null;
		}
		return (
			<PendingRequestContainer>
				<Centerer>
					<div className="messages">
						{
							pendingRequests.map((request, index) => {
								return (
									<div className="message" key={index}>
										{request.get('message')}
										<Icon
											name="spinner"
											spin
											spinDuration="0.5s"
										/>

									</div>
								);
							})
						}
					</div>
				</Centerer>
			</PendingRequestContainer>
		);
	}


	render() {
		const data = this.props.data;
		if (!data) {
			return null;
		}
		const pendingRequests = data.get('pendingRequests') || EMPTY_LIST;
		const messageBoxes = data.get('messageBoxes') || EMPTY_LIST;
		if (pendingRequests.size > 0) {
			return (
				<RootModalContainer>
					{this.renderPendingRequests(pendingRequests)}
				</RootModalContainer>
			);
		} else if (messageBoxes.size > 0) {
			return (
				<RootModalContainer>
					<MessageBox
						data={messageBoxes.get(messageBoxes.size - 1)}
					/>
				</RootModalContainer>
			)
		} else {
			return null;
		}
	}
}

class MessageBox extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {input: props.data.getIn(['options', 'input']) || ''}
		this.ok = this.ok.bind(this);
		this.ref = React.createRef();
	}


	ok() {
		const data = this.props.data;
		const type = data.getIn(['options', 'type']);
		const optional = data.getIn(['options', 'optional']);
		const callback = data.get('callback') || noop;
		if (type === 'confirm') {
			callback('yes');
		} else if (type === 'input' || type === 'multilineInput') {
			const value = this.state.input.trim();
			if (value || optional) {
				callback(this.state.input);
			} else {
				this.setState({
					inputError: 'Povinné pole'
				});
			}
		} else {
			callback('ok');
		}

	}

	componentDidMount() {
		const data = this.props.data;
		const options = data.get('options') || EMPTY_MAP;
		const type = options.get('type') || 'messageBox';
		if (type !== 'input') {
			this.ref.current.focus();
		}
	}

	render() {
		const data = this.props.data;
		const options = data.get('options') || EMPTY_MAP;
		const type = options.get('type') || 'messageBox';
		const callback = data.get('callback') || noop;
		const header = options.get('header');
		const multiline = options.get('multiline');
		const message = data.get('message');
		const yesIsNegative = options.get('yesIsNegative');
		return (
			<MessageBoxContainer
				tabIndex="-1"
				ref={this.ref}
				onKeyDown={e => {
					if (type !== 'input') {
						const keyCode = e.keyCode;
						if (keyCode === 27) {
							callback('no');
						} else if (keyCode === 13) {
							callback(type === 'confirm' ? 'yes' : 'ok');
						}
					}
				}}
			>
				<Centerer>
					<Dialog>
						{
							header && (
								<MessageBoxHeader>{header}</MessageBoxHeader>
							)
						}
						<DialogContent>
							{
								type === 'input' ? (
									<Form vertical={true} virtual>
										<FormItem
											label={data.get('message')}
											error={this.state.inputError}
											noFocusMarker
										>
											<TextInput
												value={this.state.input}
												onChange={value => {
													this.setState({
														input: value
													});
												}}
												onKeyDown={e => {
													if (e.keyCode === 13) {
														if (!multiline || e.ctrlKey) {
															this.ok();
														}
													} else if (e.keyCode === 27) {
														callback(null);
													}
												}}
												minWidth={multiline ? '400px' : null}
												minHeight={multiline ? '96px' : null}
												multiline={multiline}
												maxLength={options.get('maxLength')}

											/>
										</FormItem>
									</Form>
								) : (typeof message === 'function' ? message() : message)
							}
						</DialogContent>
						<Buttons>
							{
								type === 'confirm' && (
									<Button
										text={getPhrase('no')}
										onAction={() => {
											callback('no');
										}}
										type="light"
									/>
								)
							}
							{
								type === 'input' && (
									<Button
										text={getPhrase('cancel')}
										type="light"
										onAction={() => {
											callback(null);
										}}
									/>
								)
							}
							<Button
								text={type === 'confirm' ? getPhrase('yes') : getPhrase('ok')}
								onAction={this.ok}
								negative={yesIsNegative}
							/>

						</Buttons>
					</Dialog>
				</Centerer>
			</MessageBoxContainer>
		)
	}

}
